import { render, staticRenderFns } from "./columns-picker.vue?vue&type=template&id=522d172c&"
import script from "./columns-picker.vue?vue&type=script&lang=ts&"
export * from "./columns-picker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports